export default "__VITE_ASSET__874765d9__"